import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CssBaseline, Container } from "@mui/material";
import { Outlet } from "react-router-dom";
import AccountToolbar from "../Account/AccountToolbar";
import AlertMessage from "./AlertMessage";
import AppBar from "@mui/material/AppBar";
import { useGetCustomerProgramTypesQuery } from "../../store/account/api";
import LoadingScreen from "./LoadingScreen";
import ChooseProgramType from "../Account/ChooseProgramType";
import { accountActions } from "../../store/account/slice";
import {
  DEFAULT_PROGRAM_TYPE,
  TYPE_CCATS,
} from "../../store/account/constants";
import { Typography } from "@mui/material";
import { Stack } from "@mui/material";
import BugReportDialog from "./BugReportDialog";
import {useEffect, useState} from "react";
import AlertDialog from "./AlertDialog";
import {uiActions} from "../../store/ui/slice";

const AccountLayout = () => {
  const alert = useSelector((state) => state.ui.alert);
  const { customerId, masquerading } = useSelector((state) => state.auth);
  const { programType, programTypeChosen } = useSelector(
    (state) => state.account
  );
  const adminMessages = useSelector((state) => state.ui.adminMessages);
  const dispatch = useDispatch();
  const [bugDialogOpen, setBugDialogOpen] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);

  const {
    data: programTypes,
    error,
    isFetching,
    isSuccess,
    isError,
  } = useGetCustomerProgramTypesQuery(customerId);

  useEffect(() => {
    document.getElementById("background_image").style.display = "none";
  });

    useEffect(() => {
        //scroll to bottom of page
        window.scrollTo(0, document.body.scrollHeight);
    }, [showFAQ]);

  //const broken = undefined.nope;

  if (isFetching) {
    return <LoadingScreen />;
  }

  if (isError) {
    console.error(error.error);
    return <AlertMessage open severity="error" message={error.error} />;
  }

  function updateProgramType(programType, year) {
    dispatch(accountActions.setProgramType(programType));
    dispatch(accountActions.setYear(year));
    dispatch(accountActions.setProgramTypeChosen(true));
  }

  // //switch the program type if there are no sessions for the current program type
  // if (isSuccess && !masquerading) {
  //   let hasType = false;
  //   let type = DEFAULT_PROGRAM_TYPE;
  //   let year = "";
  //   programTypes.forEach((pType) => {
  //     if (!hasType) {
  //       //if the currently set program type is in the customer's list of program types
  //       if (pType.name.includes(programType)) {
  //         hasType = true;
  //       } else {
  //         type = pType.name;
  //         year = pType.year;
  //       }
  //     }
  //   });
  //   if (!hasType) {
  //     if (type.includes(TYPE_CCATS)) type = TYPE_CCATS;
  //     year = new Date().getFullYear();
  //     updateProgramType(type, year);
  //   }
  // }

  // if (isSuccess && programTypes.length < 2) {
  //   if (programTypes.length === 1) {
  //     updateProgramType(programTypes[0].name, programTypes[0].year);
  //   } else updateProgramType(DEFAULT_PROGRAM_TYPE, new Date().getFullYear());
  // }

  function closeBugDialog() {
    setBugDialogOpen(false);
  }

  function closeAdminMessage(index) {
    dispatch(uiActions.closeAdminMessage(index));
  }

  function toggleShowFAQ() {
      setShowFAQ(!showFAQ);
  }

  function getFAQ() {
      return (
          <>
          <br/>
          <h3 style={{marginBottom: 0}}>Frequently Asked Questions</h3>
          <h4 style={{marginBottom: 0, marginTop: '10px'}}>Is registration open yet?</h4>
              {programType.includes("Summer Camp") && (
                  <p style={{marginTop: '7px'}}>If you do not see any program or session options when registering,
                      registration is not yet open. Registration typically opens around Thanksgiving.
                      Please check our <a href="https://www.instagram.com/ylicamps/" target="_blank">Instagram</a> for
                      updates.</p>
              )}
            {programType.includes("C-CATS") && (
                <p style={{marginTop: '7px'}}>If you do not see any program or session options when registering,
                    registration is not yet open. The opening date is listed in the nomination letter you received
                    from us. This is typically in early January for Spring sessions.</p>
            )}
          <h4 style={{marginBottom: 0, marginTop: '10px'}}>Where can I find available session dates?</h4>
              {programType.includes("Summer Camp") && (<p style={{marginTop: '5px'}}>Please visit <a href="https://ylicamps.com/" target="_blank">ylicamps.com</a>, choose a camp, and click <b>Dates & Rates</b> at the top of the page.</p>)}
              {programType.includes("C-CATS") && (<p style={{marginTop: '5px'}}>Please visit <a href="https://c-cats.org/" target="_blank">c-cats.org</a>, choose middle or high school, and click <b>Dates</b> at the top of the page.</p>)}
          {programType.includes("C-CATS") && (
              <>
                  <h4 style={{marginBottom: 0, marginTop: '10px'}}>Will my child attend every weekend of C-CATS?</h4>
                  <p style={{marginTop: '5px'}}>No. Each C-CATS session happens over a single weekend. You may register for multiple weekends if you'd like, but you must pay the full cost for each additional one.</p>
              </>
            )}
          </>
      )
  }

    return programTypeChosen ? (
        <React.Fragment>
            {
                adminMessages.map((message, index) => {
                    return (
                    <AlertDialog
                        key={index}
                        title="Important Message from the Admin Team"
                        text={message.text}
                        isOpen={message.isOpen}
                        onSecondOption={() => closeAdminMessage(index)}
                        secondOptionText="Close"
                    />
                );
            })
        }
      <BugReportDialog
        open={bugDialogOpen}
        closeDialog={closeBugDialog}
        inErrorBoundary={false}
      />
      <CssBaseline />
      {programTypeChosen && (
        <AppBar position="static">
          <Container maxWidth="xl">
            <AccountToolbar />
          </Container>
        </AppBar>
      )}
      <Stack direction="column">
        <Container
          maxWidth="md"
          sx={{
            marginTop: 4,
            background: "white",
            paddingTop: "1px",
            paddingBottom: "15px",
            paddingLeft: "15px",
            paddingRight: "15px",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 0,
          }}
        >
          <Outlet />
          <AlertMessage
            open={alert.open}
            message={alert.message}
            severity={alert.severity}
          />
        </Container>
          <Container
              maxWidth="md"
              sx={{
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  paddingLeft: "5px",
                  marginBottom: "16px",
                  marginTop: 0,
                  bgcolor: "#FFFFFF",
              }}
          >
              <Typography variant="body" sx={{float: "left"}}>
                  Questions? Check the <button
                  style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "#069",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontFamily: "arial, sans-serif",
                      fontSize: "12pt",
                  }}
                  onClick={() => toggleShowFAQ()}
              >FAQ</button> or call 864-878-1103
              </Typography>
              <button
                  style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "#069",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontFamily: "arial, sans-serif",
                      fontSize: "12pt",
                      float: "right",
                  }}
                  onClick={() => setBugDialogOpen(true)}
              >
                  Report a bug
              </button>
              { showFAQ && getFAQ()}
          </Container>
      </Stack>
    </React.Fragment>
  ) : (
      <ChooseProgramType
          programTypes={programTypes}
          onProgramTypeChosen={updateProgramType}
      />
  );
};

export default AccountLayout;
